import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromCreditReport from './credit-report.reducer';

export interface CreditReportState {
  details: fromCreditReport.CreditReportDetailsState;
}

export const reducers: ActionReducerMap<CreditReportState> = {
  details: fromCreditReport.reducer
};

export const getCreditReportState = createFeatureSelector<CreditReportState>('CreditReport');

export * from './credit-report.reducer';
